// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"cf1bddbc","186":"3eb2a149","225":"263ae770","344":"7617281d","372":"82a35cd7","377":"d3286c58","443":"ee73672c","738":"d7b87ba7","841":"9269aa13","856":"fc64d6a1"}[chunkId] + ".chunk.js";
};